import { configureStore } from '@reduxjs/toolkit'

import { formUploaderReducer } from './features/formUploader/formUploaderSlice'

export const store = configureStore({
	reducer: {
		formUploader: formUploaderReducer
	}
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
